import { AutocompleteSuggestion } from '@/infrastructure/AutocompleteSuggestion';
import { areasAll } from '@studyportals/static-domain-data/areas/areas';
import { countriesAll } from '@studyportals/static-domain-data/countries/countries';
import { continentsAll } from '@studyportals/static-domain-data/continents/continents';
import { LocationType } from './LocationTypeEnum';
import { FilterKey } from '@/models/FilterKey';
import { AutocompleteSuggestionEnhanced } from '@/infrastructure/AutocompleteSuggestionEnhanced';

export class Locations {

	private locations: AutocompleteSuggestionEnhanced[] = [];

	public constructor() {
		this.locations = areasAll.map(a => {
			return {
				id: +a.id,
				name: a.name,
				type: LocationType.STATE,
				key: FilterKey.AREA
			};
		});

		this.locations.push(...countriesAll.map(c => {
			return {
				id: +c.id,
				name: c.name,
				type: LocationType.COUNTRY,
				key: FilterKey.COUNTRY
			};
		}));

		this.locations.push(...continentsAll.map(c => {
			return {
				id: +c.id,
				name: c.name,
				type: LocationType.CONTINENT,
				key: FilterKey.CONTINENT
			};
		}));
	}

	public getLocationsBy(query: string): AutocompleteSuggestion[] {
		if (query.length < 2) {
			return [];
		}
		return this.locations.filter(l => l.name.toLowerCase().includes(query.toLowerCase()));
	}
}
